import { createStore } from 'vuex'

const userMenu = {
    state: {
        account: null,
        avatar: null,
        companyId: null,
        phoneNumber: null,
        name: null,
        role: 0,
        valid: true,
        expiration: null
    },
    mutations: {
        setAccount(state, account) {
            state.account = account;
        },
        setAvatar(state, avatar) {
            state.avatar = avatar;
        },
        setName(state, name) {
            state.name = name;
        },
        setCompanyId(state, companyId) {
            state.companyId = companyId;
        },
        setPhoneNumber(state, phoneNumber) {
            state.phoneNumber = phoneNumber;
        },
        setRole(state, role) {
            state.role = role;
        },
        setValid(state, valid) {
            state.valid = valid;
        },
        setExpiration(state, expiration) {
            state.expiration = expiration;
        }
    },
    actions: {
        setUser({ commit }, user) {
            commit('setAccount', user.account);
            commit('setAvatar', user.avatar);
            commit('setName', user.name);
            commit('setCompanyId', user.companyId);
            commit('setPhoneNumber', user.phoneNumber);
            commit('setRole', user.role);
            commit('setValid', user.valid);
            commit('setExpiration', user.expiration);
        },
        setRole({ commit }, role) {
            commit('setRole', role);
        }
    }
}

const language = {
    state: {
        locale: 'zh-cn'
    },
    mutations: {
        setLanguage(state, value) {
            state.locale = value;
        }
    }
}

export default createStore({
    modules: {
        userMenu: userMenu,
        language: language
    }
});
